"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("../input"));

var _useDebounce = _interopRequireDefault(require("../useDebounce"));

var _usePrevious = _interopRequireDefault(require("../usePrevious"));

var _excluded = ["integerOnly", "value", "onChange", "onError", "min", "max", "debounceTime", "fractionDigits", "locale"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sanitizeNumber = function sanitizeNumber(value) {
  if (typeof value === 'string') {
    return value.trim().replace(/,/g, '.');
  }

  return value;
};

var isValidNumber = function isValidNumber(value) {
  if (value === null) return false;
  var val = sanitizeNumber(value); // const number = parseFloat(value);

  return !Number.isNaN(+val) && Number.isFinite(+val);
};

var NumberInput = function NumberInput(_ref) {
  var integerOnly = _ref.integerOnly,
      initialValue = _ref.value,
      onChange = _ref.onChange,
      onError = _ref.onError,
      min = _ref.min,
      max = _ref.max,
      debounceTime = _ref.debounceTime,
      fractionDigits = _ref.fractionDigits,
      locale = _ref.locale,
      other = _objectWithoutProperties(_ref, _excluded);

  var convert = function convert(newValue) {
    return newValue;
  };

  if (fractionDigits) {
    convert = function convert(newValue) {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(parseFloat(newValue));
    };
  }

  var firstUpdate = (0, _react.useRef)(true);

  var _useState = (0, _react.useState)(initialValue !== null ? convert(initialValue) : ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var debouncedValue = (0, _useDebounce["default"])(value, debounceTime);
  var prevDebounceValue = (0, _usePrevious["default"])(debouncedValue);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (debouncedValue !== prevDebounceValue) {
      if (isValidNumber(debouncedValue)) {
        var newValue = sanitizeNumber(debouncedValue);

        if (newValue < min || newValue > max) {
          onError(newValue);
          return;
        }

        if (newValue !== '') {
          newValue = parseFloat(newValue);

          if (integerOnly) {
            newValue = Math.trunc(newValue);
          }

          onChange(newValue);
        } else {
          onChange(null);
        }
      } else {
        onError(debouncedValue);
      }
    }
  }, [debouncedValue, integerOnly, max, min, onChange, onError, prevDebounceValue]); // make a value reset possible with value change

  var _useState3 = (0, _react.useState)(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      prevValue = _useState4[0],
      setPrevValue = _useState4[1];

  if (initialValue !== prevValue) {
    setPrevValue(initialValue);
    setValue(convert(initialValue));
  }

  return /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({}, other, {
    onChange: function onChange(newValue) {
      return setValue(newValue);
    },
    value: value
  }));
};

NumberInput.propTypes = _objectSpread(_objectSpread({}, _input["default"].propTypes), {}, {
  integerOnly: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  debounceTime: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  locale: _propTypes["default"].string,
  fractionDigits: _propTypes["default"].number
});
NumberInput.defaultProps = _objectSpread(_objectSpread({}, _input["default"].defaultProps), {}, {
  min: -Infinity,
  max: Infinity,
  value: '',
  integerOnly: false,
  // time to debounce the onChange callback (in milliseconds)
  debounceTime: 0,
  onChange: function onChange() {},
  onError: function onError() {},
  locale: 'en-GB',
  fractionDigits: null
});
var _default = NumberInput;
exports["default"] = _default;